import { Navigate, Outlet } from 'react-router-dom';
import { useSupplierAuth } from '../context/SupplierAuthContext';
import SupplierLayout from './layout/SupplierLayout';

const SupplierRoute = () => {
  const { isAuthenticated, loading, organization } = useSupplierAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black dark:border-white"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/leverancier/login" replace />;
  }

  // Check if organization is pending - show pending status page
  if (organization?.status === 'pending') {
    return (
      <SupplierLayout>
        <div className="max-w-2xl mx-auto mt-20 text-center">
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl p-8">
            <svg className="w-16 h-16 mx-auto text-yellow-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              In afwachting van goedkeuring
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Uw aanvraag wordt momenteel beoordeeld door ons team. U ontvangt een e-mail zodra uw account is goedgekeurd.
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-500">
              Organisatie: {organization?.company_name}
            </p>
          </div>
        </div>
      </SupplierLayout>
    );
  }

  // Check if organization is blocked or suspended
  if (organization?.status === 'blocked' || organization?.status === 'suspended') {
    return (
      <SupplierLayout>
        <div className="max-w-2xl mx-auto mt-20 text-center">
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-8">
            <svg className="w-16 h-16 mx-auto text-red-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Account {organization?.status === 'blocked' ? 'geblokkeerd' : 'geschorst'}
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              Neem contact op met support@spooker.nl voor meer informatie.
            </p>
          </div>
        </div>
      </SupplierLayout>
    );
  }

  return (
    <SupplierLayout>
      <Outlet />
    </SupplierLayout>
  );
};

export default SupplierRoute;
